import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { GridComponent, TableMode } from 'src/app/components/grid/grid.component';
import { FieldDataType } from 'src/app/components/grid/FieldDataType';
import { ITableData } from 'src/app/components/grid/ITableData';
import { IColumn } from 'src/app/components/grid/IColumn';
import { GridUtil } from 'src/app/components/grid/GridUtil';
import { IExaminationGroup } from 'src/app/interface/dto';
import { examinationGroupDefault } from 'src/app/interface/dtoDefaults';
import { ExamService } from 'src/app/services/exam-service.service';
import { SnackbarService } from 'src/app/services/snackbar.service';

@Component({
  selector: "app-examination-group",
  templateUrl: "./examination-group.component.html",
  styleUrls: ["./examination-group.component.scss"],
})
export class ExaminationGroupComponent implements OnInit {
  selectedExamGroups: IExaminationGroup[] = [];
  gridName = "examinationgroupsGrid";
  selectedExamGroup: IExaminationGroup = {
    examinationGroupID: "",
    name: "",
    id: 0,
    noOfExam: 0,
  };

  mode = "Add";
  @ViewChild("gridComponent") gridComponent!: GridComponent;

  data: ITableData = {
    tableRows: [],
    tableParams: {
      filterParams: [],
      sortParam: {
        fieldName: "",
        orderDirection: 0,
      },
      pageInfo: {
        previousPageSize: 50,
        page: 1,
        pageSize: 50,
        recordCount: 0,
        pageCount: 0,
      },
      tableMode: TableMode.serverProcessing,
      selectAll: false
    },
  };

  columns: IColumn[] = [
    {
      displayName: "Examination Group",
      fieldName: "examinationGroupID",
      fieldDataType: FieldDataType.text,
      searchable: true,
      orderable: true,

    },
    {
      displayName: "Name",
      fieldName: "name",
      fieldDataType: FieldDataType.text,
      searchable: true,
      orderable: true,

    },
    {
      displayName: "No of Exams",
      fieldName: "noOfExams",
      fieldDataType: FieldDataType.number,
      searchable: true,
      orderable: true,

    },
  ];

  constructor(
    private snackBar: SnackbarService,
    private examService: ExamService,
    private cdRef: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    this.setExamGroup([]);
    if (this.selectedExamGroup.id) {
      this.mode = "Update";
    } else {
      this.mode = "Add";
    }
    this.setExamGroup([]);
    GridUtil.setClearGridSelection();
    this.refreshData(this.data.tableParams);
  }

  setExamGroup(examGroups: any[]) {
    this.selectedExamGroups = examGroups;
    this.examService.setSelectedExamGroup([...this.selectedExamGroups]);
  }

  async refreshData(tableParams) {
    const res = (await this.examService.getExamGroups(tableParams)) as any[];
    this.updateGridParams(res);
  }

  updateGridParams(res: any) {
    this.data.tableRows = [];
    const tableParams = { ...this.data.tableParams, pageInfo: res[0].pageInfo };
    this.data.tableParams = tableParams;
    this.data.tableRows.push(...res.slice(1, res.length));
  }

  addExamGroup() {
    if (this.mode === "Add") {
      return;
    }

    this.mode = "Add";
    this.selectedExamGroup = {
      examinationGroupID: "",
      name: "",
      id: 0,
      noOfExam: 0,
    };

    this.gridComponent.resetRowSelected();
    this.cdRef.detectChanges();
  }

  rowSelectedEvent(examGroupRowId: any) {
    this.selectedExamGroup =
      (this.data.tableRows[examGroupRowId[0]] as IExaminationGroup) ??
      examinationGroupDefault;
    if (this.selectedExamGroup.id) {
      this.mode = "Update";
    } else {
      this.mode = "Add";
    }

    let storedIds = GridUtil.getSelectedDataID(this.gridName) ?? [];
    const selectedExamGroup: any[] = [];
    examGroupRowId.forEach(x => selectedExamGroup.push(this.data.tableRows[x]));

    let selectedDataRowsId = storedIds.length > 0 ? storedIds : selectedExamGroup.map(x => x.id);
    GridUtil.setRowCliclk(this.gridName, examGroupRowId, selectedDataRowsId);
    this.setExamGroup(selectedExamGroup);
  }

  async deleteExamGroup() {
    await this.examService
      .deleteExamGroup(this.selectedExamGroup)
      .then(async (response: any) => {
        this.snackBar.success("Examination Group deleted");
        await this.refreshData(this.data.tableParams);
        this.addExamGroup();
      });
  }

  async submitExamGroup() {
    if (this.selectedExamGroup.examinationGroupID === "") {
      return this.snackBar.warning("Examination Group Id field is required");
    }
    if (this.selectedExamGroup.name === "") {
      return this.snackBar.warning("Name field is required");
    }

    await this.examService
      .saveExamGroup(this.selectedExamGroup)
      .then((s: any) => {
        this.snackBar.success("Examination Group saved");
        this.refreshData(this.data.tableParams);
        if (this.mode === "Add") {
          this.selectedExamGroup = {
            examinationGroupID: "",
            name: "",
            id: 0,
            noOfExam: 0,
          };
        }
      });
  }
}
